<script>

    import NumeralMethods from '../$methods/numeral.methods'

    export let found = 0
    export let missing = 0
    export let withCost = 0
    export let review = 0
    export let amount = 0

</script>

<div class="review-cards">
    <div class="review-card">
        <span>Encontradas</span>
        <strong>{ found }</strong>
    </div>
    <div class="review-card">
        <span>No encontradas</span>
        <strong>{ missing }</strong>
    </div>
    <div class="review-card">
        <span>Con costo</span>
        <strong class:is-cost={ withCost > 0 }>{ withCost }</strong>
    </div>
    <div class="review-card">
        <span>En revisión</span>
        <strong class:is-review={ review > 0 }>{ review }</strong>
    </div>
    <div class="review-card">
        <span>A cobrar</span>
        <strong>{ NumeralMethods.cash(amount) }</strong>
    </div>
</div>

<style>
    .review-cards {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .review-card {
        padding: 0.85rem 1rem;
        border: 1px solid #eaebed;
        border-radius: 12px;
        background: #fff;
    }

    .review-card span {
        display: block;
        font-size: 0.8rem;
        font-weight: 600;
        color: #6b7280;
    }

    .review-card strong {
        display: block;
        margin-top: 0.2rem;
        font-size: 1.35rem;
        font-weight: 700;
        color: #1a1a1a;
        font-variant-numeric: tabular-nums;
    }

    .review-card strong.is-cost {
        color: #b7791f;
    }

    .review-card strong.is-review {
        color: #c53030;
    }

    @media screen and (max-width: 768px) {
        .review-cards {
            grid-template-columns: 1fr 1fr;
        }
    }
</style>
